var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#ED1C24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3787 16.3668L11.66 5.77273H15.9719L15.2532 16.3668H12.3787ZM13.816 22.1855C13.1669 22.1855 12.6337 21.9768 12.2164 21.5595C11.7991 21.1423 11.5905 20.6477 11.5905 20.0759C11.5905 19.4886 11.7991 19.0018 12.2164 18.6155C12.6337 18.2136 13.1669 18.0127 13.816 18.0127C14.4805 18.0127 15.0137 18.2136 15.4155 18.6155C15.8328 19.0018 16.0414 19.4886 16.0414 20.0759C16.0414 20.6477 15.8328 21.1423 15.4155 21.5595C15.0137 21.9768 14.4805 22.1855 13.816 22.1855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderError);
export default __webpack_public_path__ + "static/media/headerError.bc04fbce776ac3b9db218ef3f7287776.svg";
export { ForwardRef as ReactComponent };